// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Automation-Trips {
  padding: 0 1rem;
}
.Automation-Trips > .card {
  margin-top: 1rem;
  padding: 2rem;
  box-shadow: var(--bs-box-shadow-sm);
}
.Automation-Trips > .card > .card-header {
  display: flex;
  justify-content: space-between;
  background-color: transparent;
}
.Automation-Trips .Lottie-Loading {
  position: fixed !important;
  top: var(--header-height) !important;
  background-color: rgba(255, 255, 255, 0.65);
}
.Automation-Trips .Lottie-Loading > h4 {
  width: 33vw;
  text-align: center;
  line-height: 3rem;
  padding-top: calc(50vh - var(--header-height));
}`, "",{"version":3,"sources":["webpack://./src/features/Automation/pages/AutomationTrips/styles.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AAAE;EACE,gBAAA;EACA,aAAA;EACA,mCAAA;AAEJ;AADI;EACE,aAAA;EACA,8BAAA;EACA,6BAAA;AAGN;AAAE;EACE,0BAAA;EACA,oCAAA;EACA,2CAAA;AAEJ;AADI;EACE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,8CAAA;AAGN","sourcesContent":[".Automation-Trips {\n  padding: 0 1rem;\n  > .card {\n    margin-top: 1rem;\n    padding: 2rem;\n    box-shadow: var(--bs-box-shadow-sm);\n    > .card-header {\n      display: flex;\n      justify-content: space-between;\n      background-color: transparent;\n    }\n  }\n  .Lottie-Loading {\n    position: fixed !important;\n    top: var(--header-height) !important;\n    background-color: rgba(255, 255, 255, 0.65);\n    > h4 {\n      width: 33vw;\n      text-align: center;\n      line-height: 3rem;\n      padding-top: calc(50vh - var(--header-height));\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
